import type { ReactNode } from "react";
import { CheckCircle2, X } from "lucide-react";

interface BrianProposalCardProps {
  message: string;
  onDismiss: () => void;
  children: ReactNode;
  actions: ReactNode;
}

export default function BrianProposalCard({
  message,
  onDismiss,
  children,
  actions,
}: BrianProposalCardProps) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
      <div className="flex items-start justify-between gap-2 border-b border-gray-100 p-4">
        <div className="flex items-start gap-2.5">
          <CheckCircle2 size={15} className="mt-0.5 shrink-0 text-green-500" aria-hidden="true" />
          <p className="text-sm text-gray-800">{message}</p>
        </div>
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 rounded p-0.5 text-gray-400 hover:text-gray-600"
          aria-label="Dismiss Brian proposal"
        >
          <X size={14} />
        </button>
      </div>
      <div className="p-4">{children}</div>
      <div className="flex items-center justify-end gap-2 border-t border-gray-100 px-4 py-3">
        {actions}
      </div>
    </div>
  );
}
